import * as React from 'react'
import { useTheme } from '@mui/material/styles'
import Box from '@mui/material/Box'
import MobileStepper from '@mui/material/MobileStepper'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
// import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
// import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import SwipeableViews from 'react-swipeable-views-react-18-fix'
import { autoPlay } from 'react-swipeable-views-utils-react-18-fix'
import './personal_carousel.scss'

const AutoPlaySwipeableViews = autoPlay(SwipeableViews)

const images = [
  {
    label: 'Interviewed by Ministry of Education, GoI',
    imgPath: process.env.PUBLIC_URL + '/images/MoE_Interview.webp'
  },
  {
    label: 'Smart India Hackathon (National Winner)',
    imgPath: process.env.PUBLIC_URL + '/images/sihPrize.webp'
  },
  {
    label: 'Awarded by Suptd. Maharashtra Police',
    imgPath: process.env.PUBLIC_URL + '/images/kavach.webp'
  },
  {
    label: 'Best Internship of University',
    imgPath: process.env.PUBLIC_URL + '/images/xperia.webp'
  },
  {
    label: 'With Director, Aurbindo Institute of Tech.',
    imgPath: process.env.PUBLIC_URL + '/images/DeanPhoto.webp'
  },
  {
    label: 'With Director, NMIMS University',
    imgPath: process.env.PUBLIC_URL + '/images/DirectorPhoto.webp'
  }
]

function PersonalCarousel () {
  const theme = useTheme()
  const [activeStep, setActiveStep] = React.useState(0)
  const maxSteps = images.length

  const handleNext = () => {
    setActiveStep(prevActiveStep => prevActiveStep + 1)
  }

  const handleBack = () => {
    setActiveStep(prevActiveStep => prevActiveStep - 1)
  }

  const handleStepChange = step => {
    setActiveStep(step)
  }

  return (
    <Box className='carousel_box'>
      <Paper
        square
        elevation={0}
        sx={{
          pl: 2,
          bgcolor: 'transparent',
          background: 'rgba(8, 16, 34, 0.15)',
          backdropFilter: 'blur(20px)',
          border: '1px solid rgba(255, 255, 255, 0.15)',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)'
        }}
        className='carousel_paper'
      >
        <Typography className='image_desc'>
          <i>{images[activeStep].label}</i>
        </Typography>
      </Paper>
      <AutoPlaySwipeableViews
        axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
        index={activeStep}
        onChangeIndex={handleStepChange}
        enableMouseEvents
        className='swipeable_view'
      >
        {images.map((step, index) => (
          <div key={step.label}>
            {Math.abs(activeStep - index) <= 2 ? (
              <Box
                component='img'
                src={step.imgPath}
                alt={`Sam Varghese - ${step.label}`}
                className='swipeable_images'
                loading='eager'
              />
            ) : null}
          </div>
        ))}
      </AutoPlaySwipeableViews>
      <MobileStepper
        steps={maxSteps}
        position='static'
        activeStep={activeStep}
        className='bottom_bar'
        sx={{
          bgcolor: 'transparent',
          background: 'rgba(8, 16, 34, 0.15)',
          backdropFilter: 'blur(10px)',
          border: '1px solid rgba(255, 255, 255, 0.15)',

          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)'
        }}
        nextButton={
          <Button
            size='small'
            onClick={handleNext}
            disabled={activeStep === maxSteps - 1}
          >
            Next
            {/* {theme.direction === "rtl" ? (
                            <KeyboardArrowLeft />
                        ) : (
                            <KeyboardArrowRight />
                        )} */}
          </Button>
        }
        backButton={
          <Button size='small' onClick={handleBack} disabled={activeStep === 0}>
            {/* {theme.direction === "rtl" ? (
                            <KeyboardArrowRight />
                        ) : (
                            <KeyboardArrowLeft />
                        )} */}
            Back
          </Button>
        }
      />
    </Box>
  )
}

export default PersonalCarousel
